import type { TicketListFilters } from '../types/api';

export const queryKeys = {
  me: ['users', 'me'] as const,
  assignable: ['users', 'assignable'] as const,
  tickets: {
    all: ['tickets'] as const,
    lists: () => [...queryKeys.tickets.all, 'list'] as const,
    list: (filters: TicketListFilters) => [...queryKeys.tickets.lists(), filters] as const,
    detail: (id: string) => [...queryKeys.tickets.all, 'detail', id] as const,
    comments: (id: string) => [...queryKeys.tickets.all, 'detail', id, 'comments'] as const,
    timeline: (id: string) => [...queryKeys.tickets.all, 'detail', id, 'timeline'] as const,
  },
};
